export default [
    {
        path: '/prerequisite/measurements',

        name: 'Measurements',

        component: () => import('@/views/prerequisite/measurements'),
    },
];